import styled from 'styled-components'

const LayoutContainer = styled.div.attrs({
  className: 'section',
})`
`

export default LayoutContainer



// WEBPACK FOOTER //
// ./src/components/views/layouts/LayoutContainer.js